import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

type AnnouncementStore = {
  visitedRoutes: string[]
  addVisitedRoute: (page: string) => void
}

export const useAnnouncementStore = create<AnnouncementStore>()(
  devtools(
    persist(
      (set, get) => ({
        visitedRoutes: [],
        addVisitedRoute: (route) => {
          if (!get().visitedRoutes.includes(route)) {
            set({ visitedRoutes: [...get().visitedRoutes, route] })
          }
        },
      }),
      {
        name: 'bp-announcement-store',
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
)
